export default "__VITE_ASSET__d2ce89e1__"